var _rect, _path, _rect2, _path2, _rect3, _path3, _rect4, _path4, _rect5, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRating(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 30,
    viewBox: "0 0 158 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#00B67A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 1.5L10.5 10.5L1.5 11.625L7.695 18.555L6 28.5L15 24L24 28.5L22.32 18.555L28.5 11.625L19.5 10.5L15 1.5ZM15 4.86L18.51 11.895L25.485 12.765L20.715 18.105L22.02 25.83L15 22.32L7.98 25.83L9.285 18.105L4.515 12.765L11.49 11.895L15 4.86Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(32)",
    fill: "#00B67A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47 1.5L42.5 10.5L33.5 11.625L39.695 18.555L38 28.5L47 24L56 28.5L54.32 18.555L60.5 11.625L51.5 10.5L47 1.5ZM47 4.86L50.51 11.895L57.485 12.765L52.715 18.105L54.02 25.83L47 22.32L39.98 25.83L41.285 18.105L36.515 12.765L43.49 11.895L47 4.86Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(64)",
    fill: "#00B67A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79 1.5L74.5 10.5L65.5 11.625L71.695 18.555L70 28.5L79 24L88 28.5L86.32 18.555L92.5 11.625L83.5 10.5L79 1.5ZM79 4.86L82.51 11.895L89.485 12.765L84.715 18.105L86.02 25.83L79 22.32L71.98 25.83L73.285 18.105L68.515 12.765L75.49 11.895L79 4.86Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(96)",
    fill: "#00B67A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111 1.5L106.5 10.5L97.5 11.625L103.695 18.555L102 28.5L111 24L120 28.5L118.32 18.555L124.5 11.625L115.5 10.5L111 1.5ZM111 4.86L114.51 11.895L121.485 12.765L116.715 18.105L118.02 25.83L111 22.32L103.98 25.83L105.285 18.105L100.515 12.765L107.49 11.895L111 4.86Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(128)",
    fill: "url(#paint0_linear_131_741)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M143 1.5L138.5 10.5L129.5 11.625L135.695 18.555L134 28.5L143 24L152 28.5L150.32 18.555L156.5 11.625L147.5 10.5L143 1.5ZM143 4.86L146.51 11.895L153.485 12.765L148.715 18.105L150.02 25.83L143 22.32L135.98 25.83L137.285 18.105L132.515 12.765L139.49 11.895L143 4.86Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_131_741",
    x1: -2.15368e-9,
    y1: 15,
    x2: 30,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.494864,
    stopColor: "#00B67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567782,
    stopColor: "#828D8A",
    stopOpacity: 0.69
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.5af8bab3c811b6fdc6fcd33620ac84a1.svg";
export { ForwardRef as ReactComponent };